import { FormElement } from "./createFormStructure";
interface CreateFormEmailProps {
  formStructure: FormElement[];
  isVisible?: (field: FormElement) => boolean;
}

export const flattenFormStructure = ({
  formStructure,
  isVisible,
}: CreateFormEmailProps): FormElement[] => {
  const flattenedFields: FormElement[] = [];

  for (const field of formStructure) {
    if (isVisible && !isVisible(field)) continue;

    switch (field.type) {
      case "fieldset":
      case "column":
        flattenedFields.push(
          ...flattenFormStructure({
            formStructure: field.children || [],
            isVisible,
          }),
        );
        break;
      default:
        flattenedFields.push(field);
    }
  }

  return flattenedFields;
};
